import { useEffect, useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import { getServerSyncedTime } from '../../../utils/TimeUtils';
import { useFullTrack, useTrackPendingPracticalExercises } from '../../tracks';
import { useMostRecentExamAttempt } from '../../exams';
import ExamFinishedScreenLayout from './ExamFinishedScreenLayout';
import TrackViewAwardLink from '../../../components/TrackCard/TrackViewAwardLink';
import { useUserInfo } from '../../accounts';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import I18n from 'I18n';
import { useTrackProgress } from '../../userProgress';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ExamCongratulationsScreen = ({
  trackId,
  language,
  certificationAwardedInDifferentLanguage
}) => {
  const {
    userInfo,
    userInfoLoading,
    userInfoError
  } = useUserInfo();
  const {
    track,
    trackLoading,
    trackError
  } = useFullTrack(trackId, language);
  const {
    mostRecentExamAttempt,
    mostRecentExamAttemptLoading,
    mostRecentExamAttemptError
  } = useMostRecentExamAttempt(Number(trackId), language);
  const {
    pendingPracticalExercises,
    pendingPracticalExercisesLoading,
    pendingPracticalExercisesError
  } = useTrackPendingPracticalExercises(trackId.toString(), language);
  const examIsRecent = mostRecentExamAttempt ? getServerSyncedTime() - mostRecentExamAttempt.attemptFinishTime < 24 * 60 * 60 * 1000 : false;
  const probablyHasCert = track && (track.certification || !!track.exam) && mostRecentExamAttempt && mostRecentExamAttempt.passed && pendingPracticalExercises && !pendingPracticalExercises.length;
  const shouldPoll = certificationAwardedInDifferentLanguage ? examIsRecent : !!probablyHasCert && examIsRecent;
  const [isPolling, setIsPolling] = useState(!!shouldPoll);
  const {
    trackProgress,
    trackProgressLoading,
    trackProgressError
  } = useTrackProgress(trackId, {
    fetchPolicy: 'cache-and-network',
    polling: isPolling,
    skip: !trackId
  });
  const award = trackProgress === null || trackProgress === void 0 ? void 0 : trackProgress.award;
  useEffect(() => {
    if (award && !certificationAwardedInDifferentLanguage) {
      setIsPolling(false);
    }
  }, [award, certificationAwardedInDifferentLanguage]);
  const awardReadyForDifferentLanguage = certificationAwardedInDifferentLanguage ? (award === null || award === void 0 ? void 0 : award.trackIdAward) === trackId : true;
  const showTrackViewAwardLink = !certificationAwardedInDifferentLanguage || awardReadyForDifferentLanguage;
  const passDate = mostRecentExamAttempt ? mostRecentExamAttempt.attemptFinishTime : award ? award.awardedAt : undefined;
  const awardNotYetLoaded = !award && probablyHasCert && examIsRecent;
  const showLoadingSpinner = awardNotYetLoaded || !showTrackViewAwardLink;
  return /*#__PURE__*/_jsx(ExamFinishedScreenLayout, {
    callToAction: /*#__PURE__*/_jsxs(_Fragment, {
      children: [showLoadingSpinner && /*#__PURE__*/_jsx(LoadingSpinner, {
        label: I18n.text('learningCenter.exams.finished.loadingCertificate'),
        showLabel: true
      }), showTrackViewAwardLink && /*#__PURE__*/_jsx(TrackViewAwardLink, {
        award: award,
        certification: track && (track.certification || !!track.exam),
        trackId: trackId,
        useCurrentText: mostRecentExamAttempt ? !mostRecentExamAttempt.passed : false
      })]
    }),
    error: trackError || mostRecentExamAttemptError || pendingPracticalExercisesError || trackProgressError || userInfoError,
    heading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.exams.finished.successHeading",
      options: {
        firstName: userInfo && userInfo.user.firstName
      }
    }),
    illustration: "trophy",
    language: language,
    loading: trackLoading || mostRecentExamAttemptLoading || pendingPracticalExercisesLoading || trackProgressLoading || userInfoLoading,
    prompt: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.exams.finished.yourScoreWas",
      options: {
        correctQuestionCount: mostRecentExamAttempt && mostRecentExamAttempt.score,
        totalQuestionCount: track && track.exam.length
      }
    }),
    showSecondaryRetakeCTA: true,
    subheading: passDate && /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "learningCenter.exams.finished.passedOnSubheading",
      options: {
        courseName: track && track.name,
        passDate: /*#__PURE__*/_jsx(FormattedDateTime, {
          format: "ll",
          value: passDate
        })
      }
    }),
    trackId: trackId
  });
};
export default ExamCongratulationsScreen;